<!-- チェック場所 -->
<template>
  <div class="column">
    <div class="item">
      <div class="label">
        <div>チェック場所</div>
        <div>Check place</div>
      </div>
      <div class="value">
        {{ locationName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SFaceCheckinDisp",
  props: {
    locationName: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 11px;
  line-height: 21px;
}

.value {
  margin-top: 5px;
  font-size: 8vw;
  font-weight: bold;
}
</style>
